import React, { useMemo } from 'react'
import { rightSelector } from '../../../../../../../../../../../modules/selectors/rights'
import { useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../../../../../../features/components/Form/MultiSelectBox'
import SubAllocationMultiFieldItem from '../SubAllocationMultiFieldItem'

import { formatRightInventoryOptions, getGamInventoryType, inventoryTypes } from '../../../../../../helpers'

import { RIGHT_INVENTORY_SELECT } from '../../../../../../fields'
import { AD_INVENTORY } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useStyles from './styles'

const RightInventorySelect = ({ formik }) => {
  const right = useSelector(rightSelector)

  const classes = useStyles()

  const formattedOptions = useMemo(() => {
    return formatRightInventoryOptions(right[AD_INVENTORY])
  }, [right])

  const placeholder = useMemo(() => {
    const inventoryType = getGamInventoryType(right[AD_INVENTORY])
    return inventoryType === inventoryTypes.placements ? 'Add a placement' : 'Add ad unit'
  }, [right])

  const { values, setFieldValue } = formik

  return (
    <MultiSelectBox
      options={formattedOptions}
      value={values[RIGHT_INVENTORY_SELECT]}
      name={RIGHT_INVENTORY_SELECT}
      setFieldValue={setFieldValue}
      className={
        values[RIGHT_INVENTORY_SELECT].length > 0
          ? // if has selected values - reset margin because we show header in this case and it has its own margin
            classes.resetTopMargin
          : ''
      }
      placeholder={placeholder}
      CustomMultiFieldItem={<SubAllocationMultiFieldItem formik={formik} />}
    />
  )
}

export default RightInventorySelect
